// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/lanluma/story-section-1-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

html[dir='rtl'] .lanluma-story-section-1 .image-box>div>div,
html[dir='rtl'] .ellanse-story-section-1 .image-box>div>div {
    transform: none !important;

}

@media(min-width: 992px) {
    html[dir='ltr'] .story-section-parent

    /* ,
    html[dir='rtl'] .story-section-parent.reverse  */
        {
        padding-left: 48px !important;
        padding-right: 72px !important;
    }

    html[dir='rtl'] .story-section-parent {
        padding-right: 48px !important;
        padding-left: 72px !important;
    }

    html[dir='ltr'] .story-section-parent.reverse {
        padding-right: 48px !important;
        padding-left: 96px !important;
    }


    html[dir='rtl'] .story-section-parent.reverse {
        padding-right: 32px !important;
        padding-left: 0 !important;
    }

    .story-section-parent .min-height-controller {
        min-height: 440px;
    }
.story-section-parent .story-section-text-holder{
    min-width: 450px;
}
    .story-section-parent .first-stack {
        padding-bottom: 0 !important;
        padding-top: 75px !important;
    }

    html[dir='ltr'] .story-section-parent.lanluma-story-section-1 .first-stack {
        padding-left: 40px !important;
        padding-right: 0 !important;
    }
    .story-section-parent.lanluma-story-section-1{
        padding-top: 0;
        padding-bottom: 0;
    }
    .story-section-parent.lanluma-story-section-2{
        padding-top: 0;
        /* padding-bottom: 0; */
    }
    html[dir='ltr'] .story-section-parent .first-stack {
        padding-left: 32px !important;
    }

    html[dir='rtl'] .story-section-parent .first-stack {
        padding-right: 32px !important;
        padding-left: 0 !important;
    }


    .dimono-story-section-1 .first-stack {
        padding-right: 32px;
    }

    .dimono-story-section-1 {
        padding-bottom: 0 !important;
    }

    .lanluma-story-section-2 .image-box>div {
        height: 400px;
        top: 0;
    }

    html[dir='rtl'] .lanluma-story-section-2 .image-box>div {
        height: 420px;
    }

    /* html[dir='rtl'] .lanluma-story-section-2 .image-box>div {
        height: 420px;
    } */



    .ellanse-story-section-3 .first-stack {
        /* padding-top: 35px !important; */
    }

    .renee-story-1 .min-height-controller {
        min-height: 430px !important;
    }

    .story-section-parent.drcyj-story-1 .min-height-controller {
        min-height: 447px !important;
    }

    .ksurgery-story-2 .min-height-controller {
        min-height: 435px !important;
    }

    .story-section-parent.ksurgery-story-2 .first-stack,

    .story-section-parent.lanluma-story-section-2 .first-stack {



        padding-left: 0 !important;
        padding-right: 32px !important;
    }



    .story-section-parent.ellanse-story-section-2 .min-height-controller {
        min-height: 450px;
    }

    .story-section-parent.ellanse-story-section-2 .first-stack {
        padding-left: 0 !important;

        padding-right: 48px !important;
    }



    .story-section-parent.maili-story-section-2 .first-stack,

    .story-section-parent.maili-story-section-1 .first-stack {
        padding-right: 48px;
        padding-left: 0;
    }

    html[dir='rtl'] .story-section-parent.maili-story-section-2 .first-stack,
    html[dir='rtl'] .story-section-parent.maili-story-section-1 .first-stack {
        padding-right: 0px;
        padding-left: 48px;
    }



    html[dir='rtl'] .story-section-parent.ksurgery-story-2 .first-stack,

    html[dir='rtl'] .story-section-parent.lanluma-story-section-2 .first-stack {



        padding-right: 0 !important;
        padding-left: 32px !important;
    }

    html[dir='rtl'] .story-section-parent.ellanse-story-section-2 .first-stack {
        padding-right: 0 !important;

        padding-left: 48px !important;
    }

    html[dir='rtl'] .story-section-parent.maili-story-section-2.reverse {
        padding-right: 102px !important;
        padding-left: 0 !important;
    }


    .story-section-parent.dimono-story-2 .first-stack,
    .story-section-parent.lanluma-story-section-3 .first-stack {
        padding-right: 0 !important;
    }

    html[dir='rtl'] .story-section-parent.dimono-story-2 .first-stack {
        padding-right: 96px !important;
        padding-left: 0 !important;
    }

    .story-section-parent.ellanse-story-section-1 span,
    .story-section-parent.ellanse-story-section-2 span,
    .story-section-parent.ellanse-story-section-3 span {
        font-size: 18px !important;

    }

    .story-section-parent.renee-story-1 .first-stack {
        padding-top: 48px !important;
        padding-left: 84px !important;
        padding-right: 56px !important;
    }


    .story-section-parent.renee-story-2 ul {
        padding-left: 12px;

    }

    html[dir='rtl'] .story-section-parent.renee-story-2 ul {
        padding-right: 12px !important;

    }

    .story-section-parent.renee-story-2 .first-stack {
        padding-top: 70px !important;
    }


    .story-section-parent.ellanse-story-section-1 .first-stack {
        padding-left: 88px;

    }

    .story-section-parent.ellanse-story-section-3 .min-height-controller {
        min-height: 440px !important;
    }




    .story-section-parent .min-height-controller h3 {
        font-size: 24px;
        padding-top: 0 !important;
    }

    .story-section-parent .min-height-controller h3+p,
    .story-section-parent .min-height-controller h3+span {
        font-size: 18px;
        line-height: 1.4;
        text-align: justify;
        margin-top: 16px !important;
        letter-spacing: 0;
    }

    /* .story-section-parent .min-height-controller h3+ p,
    .story-section-parent .min-height-controller h3+span {
        margin-top: 0 !important;
    } */

    html[dir='rtl'] .lanluma-story-section-2.story-section-parent.reverse {
        padding-right: 96px !important;
    }

    html[dir='rtl'] .maili-story-section-2.story-section-parent.reverse .first-stack {
        padding-left: 56px !important;
    }

    html[dir='ltr'] .maili-story-section-2.story-section-parent.reverse,

    html[dir='ltr'] .ksurgery-story-2.story-section-parent.reverse {
        padding-left: 102px !important;
    }

    html[dir='ltr'] .drcyj-story-section-1.story-section-parent .first-stack,
    html[dir='ltr'] .ksurgery-story-1.story-section-parent .first-stack {
        padding-right: 0 !important;
    }

    html[dir='ltr'] .renee-story-2.story-section-parent.reverse {
        padding-left: 124px !important;
    }

    html[dir='rtl'] .renee-story-2.story-section-parent.reverse {
        padding-right: 124px !important;
        padding-left: 48px !important;
    }

    .renee-story-2.story-section-parent.reverse h3 {
        padding-top: 0 !important;
    }

    html[dir='ltr'] .ksurgery-story-2.story-section-parent.reverse .first-stack {
        padding-right: 56px !important;
    }

    html[dir='rtl'] .ksurgery-story-2.story-section-parent.reverse {
        /* padding-left: 56px!important; */
        padding-right: 102px !important;

    }

    html[dir='rtl'] .ksurgery-story-2.story-section-parent.reverse .first-stack {
        padding-left: 48px !important;
    }


}


@media(min-width: 1440px){
    html[dir='ltr'] .story-section-parent.reverse {
        padding-right: 0 !important;
        padding-left: 102px !important;
    }
    html[dir='rtl'] .story-section-parent.reverse {
        padding-left: 0 !important;
        padding-right: 102px !important;
    }
    html[dir='ltr'] .story-section-parent.reverse {
        padding-right: 0 !important;
        padding-left: 96px !important;
    }
    .lanluma-story-section-2 .image-box>div {
        height: 420px;
        top: 0;
    }
    html[dir='ltr'] .story-section-parent.renee-story-1 .first-stack {
     
        padding-right: 86px !important;
    }
    html[dir='ltr'] .story-section-parent.maili-story-section-1 .first-stack,
    
   html[dir='ltr'] .story-section-parent.ellanse-story-section-1 .first-stack,
   html[dir='ltr'] .story-section-parent.ellanse-story-section-3 .first-stack,
   html[dir='ltr'] .story-section-parent.dimono-story-section-1 .first-stack

    {
        padding-left: 40px;
        padding-right: 0;
    }
}



@media(min-width: 768px) and (max-width: 991px) {

    .story-section-parent .min-height-controller {
        height: 350px;
    }


    .story-section-parent>div {
        padding: 0 !important;
    }

    .story-section-parent {
        /* padding-left: 48px;
        padding-right: 48px; */
        padding-left: 64px;
        padding-right: 64px;
    }

    .story-section-parent .first-stack {
        padding-bottom: 0 !important;
        padding-right: 36px;

    }

    .story-section-parent .image-box>div>div {
        background-position: center;
    }


    .story-section-parent .first-stack h3 {
        font-size: 1.25rem;
    }

    .story-section-parent span,
    .story-section-parent p {
        text-align: justify !important;
        font-size: 14px;
        line-height: 1.4 !important;
    }

    .story-section-parent.renee-story-1 {
        padding-left: 60px;
        padding-right: 60px;
    }

    .story-section-parent.renee-story-2 {
        padding-left: 88px !important;
        padding-right: 88px !important;
    }

    .story-section-parent.renee-story-2 ul {
        width: 100% !important;
    }

    .story-section-parent.ksurgery-story-1 {

        padding-left: 60px;
        padding-right: 60px;
    }

    .story-section-parent.ksurgery-story-2 {
        padding-left: 64px;
        padding-right: 64px;
    }

    .story-section-parent.ksurgery-story-1 span {
        /* word-spacing: 0; */
        letter-spacing: 0;
    }

    html[dir='rtl'] .ksurgery-story-1.story-section-parent .first-stack {
        padding-left: 0 !important;
        padding-right: 48px !important;
    }

    html[dir='rtl'] .ksurgery-story-2.story-section-parent .first-stack {
        padding-right: 0 !important;
        padding-left: 60px !important;
    }

    .renee-story-1 p {
        font-size: 14px !important;

    }

    .renee-story-1 .first-stack {
        padding-right: 40px;

    }

    .drcyj-story-section-1 .first-stack {
        padding-left: 48px !important;
        padding-right: 0px !important;
        padding-top: 40px !important;
        padding-bottom: 48px !important;
    }

    .renee-story-2 .first-stack {
        padding-left: 0;
        padding-right: 100px;
        padding-top: 32px;
        padding-bottom: 64px;
    }

    .renee-story-2 .first-stack ul {
        padding-left: 12px !important;
        line-height: 1.6;
    }

    .renee-story-2 .first-stack li {
        font-size: 14px !important;
    }

    .ksurgery-story-1,
    .ksurgery-story-2 {
        padding-right: 12px;
        padding-left: 12px;

    }

    .ksurgery-story-1 .first-stack {
        padding-right: 0 !important;
        padding-bottom: 40px !important;
        padding-top: 36px !important;

    }

    .ksurgery-story-1 .min-height-controller {
        min-height: 350px !important;
    }

    .ksurgery-story-1 span {
        line-height: 1.4 !important;
    }

    .ksurgery-story-2 .first-stack {
        padding-left: 0 !important;
        padding-right: 48px;
    }

    .story-section-parent.ksurgery-story-2 span {
        font-size: 14px !important;
    }

    .ksurgery-story-2 .image-box>div,
    .maili-story-section-2 .image-box>div,
    .ellanse-story-section-2 .image-box>div {
        left: -56px !important;
    }

    .lanluma-story-section-1 .first-stack,

    .maili-story-section-1 .first-stack {

        padding-right: 0 !important;
    }

    .lanluma-story-section-1 .min-height-controller,
    .maili-story-section-1 .min-height-controller {
        min-height: 350px !important;
    }

    .ellanse-story-section-2 .min-height-controller {
        min-height: 400px !important;
    }

    .lanluma-story-section-1 {
        padding-left: 24px;
        padding-right: 24px;
    }

    /* .lanluma-story-section-1, */
    .lanluma-story-section-2,
    .lanluma-story-section-3,
    .maili-story-section-1,
    .maili-story-section-2,
    .ellanse-story-section-1,
    .ellanse-story-section-2,
    .ellanse-story-section-3,
    .renee-story-1,
    .drcyj-story-section-1,
    .dimono-story-section-1 {
        padding-left: 60px;
        padding-right: 60px;
        padding-top: 32px !important;
    }

    html[dir='rtl'] .dimono-story-section-1 .first-stack {
        padding-left: 0 !important;
        padding-right: 44px !important;
    }

    .dimono-story-section-1 span {
        word-spacing: 0;
        letter-spacing: 0;
    }

    .renee-story-2 {
        padding: 40px !important;
    }

    /* .maili-story-section-1,.maili-story-section-2{
        padding-left: 24px;
        padding-right: 24px;
    } */

    .lanluma-story-section-1 .first-stack,
    .lanluma-story-section-2 .first-stack,
    .ellanse-story-section-1 .first-stack,
    .lanluma-story-section-3 .first-stack,

    .maili-story-section-1 .first-stack {
        padding-top: 48px;

    }

    .ellanse-story-section-3 .first-stack {
        padding-top: 8px !important;
        padding-right: 8px !important;
    }

    .story-section-parent h3 {
        font-weight: 600 !important;
        font-size: 1.25rem;

    }

    .story-section-parent .first-stack {
        padding-bottom: 0 !important;
    }

    .lanluma-story-section-1 span,
    .lanluma-story-section-2 span,
    .lanluma-story-section-3 span,
    .maili-story-section-1 span,
    .ellanse-story-section-1 span,
    .ellanse-story-section-2 span,
    .ellanse-story-section-3 span,


    .drcyj-story-section-1 span {
        font-size: 14px !important;
        line-height: 1.4;
    }

    .lanluma-story-section-2 .min-height-controller,
    .maili-story-section-1 .min-height-controller,
    .ellanse-story-section-2 .min-height-controller,
    .ellanse-story-section-1 .min-height-controller,
    .ellanse-story-section-3 .min-height-controller {
        min-height: 350px !important;
    }

    .lanluma-story-section-2 .first-stack,
    .maili-story-section-2 .first-stack,
    .ellanse-story-section-2 .first-stack {
        padding-left: 0;
    }

    .lanluma-story-section-2 .image-box>div {
        left: -55px;
    }

    .lanluma-story-section-3 .min-height-controller {
        min-height: 350px !important;
    }

    .lanluma-story-section-3 .first-stack,
    .ellanse-story-section-1 .first-stack,
    .dimono-story-section-1 .first-stack {
        padding-right: 0 !important;
    }

    html[dir='rtl'] .drcyj-story-section-1 .first-stack {
        padding-left: 0 !important;
        padding-right: 48px !important;
    }

    .story-section-parent.drcyj-story-section-1 .min-height-controller {
        height: 370px;
    }

    .story-section-parent.maili-story-section-2 .first-stack {
        padding-right: 48px !important;

    }

    html[dir='rtl'] .story-section-parent.maili-story-section-2 .first-stack {
        padding-right: 0 !important;
        padding-left: 60px !important;
    }

    html[dir='rtl'] .story-section-parent.maili-story-section-1 .first-stack {
        padding-left: 0 !important;
        padding-right: 44px !important;
    }

    .story-section-parent.lanluma-story-section-1 {
        padding-left: 68px !important;
        padding-right: 68px !important;
    }

    html[dir='rtl'] .story-section-parent.lanluma-story-section-1 .first-stack {
        padding-left: 0 !important;
        padding-right: 44px !important;
    }

    html[dir='rtl'] .story-section-parent.lanluma-story-section-2 {
        padding-left: 24px !important;
        padding-right: 64px !important;
    }

    html[dir='rtl'] .story-section-parent.lanluma-story-section-2 .first-stack {

        padding-right: 0 !important;
        padding-left: 48px !important;
    }

    html[dir='rtl'] .lanluma-story-section-3 .first-stack {
        padding-left: 0 !important;
        padding-right: 48px !important;

    }

    html[dir='ltr'] .lanluma-story-section-2 {
        padding-left: 64px !important;
        padding-right: 34px !important;
    }

    html[dir='rtl'] .ellanse-story-section-1 .first-stack {
        padding-left: 0 !important;
        padding-right: 48px !important;
    }

    html[dir='rtl'] .ellanse-story-section-2 {

        padding-right: 0 !important;
        padding-left: 60px !important;
    }

    html[dir='rtl'] .ellanse-story-section-2 {
        padding-left: 40px !important;
        padding-right: 64px !important;
    }

    html[dir='rtl'] .ellanse-story-section-2 .first-stack {
        padding-right: 0;
        padding-left: 60px;
    }

    html[dir='rtl'] .ellanse-story-section-3 .first-stack {
        padding-left: 0;
        padding-right: 48px !important;
    }

    .ellanse-story-section-2 .min-height-controller {
        min-height: 400px !important;
    }

    html[dir='ltr'] .ellanse-story-section-2 {
        padding-left: 64px !important;
        padding-right: 53px !important;
    }
}

@media(min-width: 768px) {

    .ksurgery-story-1,
    .ksurgery-story-2 {
        background-color: #E0FFF5 !important;
    }
}

@media(max-width:767px) {
    .ksurgery-story-1 .image-box {
        display: none;
    }

    .ksurgery-story-2 {
        padding-top: 0 !important;
    }

    .ksurgery-story-2 .image-box {
        transform: scaleX(-1);
        height: 285px !important;
        margin-bottom: 0;

    }

    .ksurgery-story-2 .image-box>div {
        /* position: relative !important; */
        width: 105%;

        top: 0 !important;
        left: -16px;
        height: 100%;

    }

    .ksurgery-story-2 .image-box>div>div {
        background-size: cover;
        margin-top: 32px;
    }


    .renee-story-1 .image-box {
        height: 60vh;
        order: 2;
        margin-top: 36px;
    }

    .renee-story-1 .image-box>div {
        width: 105%;
        top: 0 !important;
        left: 0;
        height: 100%;
    }

    .renee-story-2 {
        padding-top: 0 !important;

        padding-left: 16px !important;
        padding-right: 16px !important;


    }

    .renee-story-2 .image-box,
    .ellanse-story-section-1 .image-box,
    .lanluma-story-section-1 .image-box {
        display: none;
    }

    .lanluma-story-section-1 {
        margin-top: 100px;
        padding-bottom: 84px !important;
    }

    html[dir='rtl'] .lanluma-story-section-1 {
        /* margin-top: 100px;
    padding-bottom: 84px !important; */
        width: 110%;
    }

    .lanluma-story-section-1 .story-section-text-holder {
        margin-top: 45px;
    }

    .lanluma-story-section-1 .story-section-text-holder {
        position: relative;
        padding-top: 0 !important;
    }

    .lanluma-story-section-1 .story-section-text-holder:before {
        content: "";
        position: absolute;
        bottom: 106%;
        left: 0;
        height: 147px;
        width: 100%;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-repeat: no-repeat;
        background-size: cover !important;
    }

    .renee-story-2 li {
        text-align: left;
    }

    html[dir='rtl'] .renee-story-2 li {
        text-align: right;
    }

    .renee-story-2 h3 {
        font-size: 1.25rem;
    }

    .ellanse-story-section-2 {
        padding-top: 0 !important;
    }

    .lanluma-story-section-1 .story-section-text-holder {
        height: 40vh;
    }

    .lanluma-story-section-1 .story-section-text-holder>div {
        padding: 32px !important;
        left: 0;
        position: relative;
        width: 100%;
        top: -15px;
    }

    html[dir='rtl'] .lanluma-story-section-1 .story-section-text-holder>div {
        padding: 32px 48px !important;

    }

    html[dir='rtl'] .lanluma-story-section-1 .story-section-text-holder:before {

        left: 49%;
        transform: translateX(-50%);
        /* bottom: 106%; */
    }

    html[dir='ltr'] .lanluma-story-section-1 {
        padding-bottom: 72px !important;
    }

    html[dir='rtl'] .lanluma-story-section-1 {
        padding-bottom: 20px !important;
    }

    html[dir='rtl'] .ellanse-story-section-2 .image-box,
    html[dir='rtl'] .ellanse-story-section-3 .image-box,
    html[dir='rtl'] .ksurgery-story-2 .image-box,
    html[dir='rtl'] .renee-story-1 .image-box {
        left: -16px !important;
    }

    .renee-story-2 ul {
        padding-left: 12px
    }

    html[dir='rtl'] .renee-story-2 ul {
        padding-right: 12px
    }

    html[dir='rtl'] .ellanse-story-section-3 {
        padding-top: 56px;
    }

    .lanluma-story-section-1 .story-section-text-holder>div {

        top: -25px;
    }

    .ellanse-story-section-2 .image-box {
        order: -1;
        padding-top: 0 !important;
        margin-top: -8px;
        transform: scaleX(-1);
        left: 16px;
    }

    .ellanse-story-section-3 .image-box>div {
        top: 0;

        left: 0;
        height: 80%;

    }

    .ellanse-story-section-3 .story-section-text-holder {
        padding-top: 0;
        margin-top: -20px;
    }

    .lanluma-story-section-2 {
        padding-top: 0 !important;
        padding-bottom: 30px !important;
        margin-top: -27px;

    }

    .lanluma-story-section-2 .image-box {
        display: none;
    }

    .lanluma-story-section-1>div>div {
        width: 100%;
        position: relative;
        left: 16px;
    }


    .lanluma-story-section-1 .story-section-text-holder {
        padding-left: 0 !important;
    }

    .lanluma-story-section-2 .story-section-text-holder {
        padding-top: 0 !important;
    }

    .lanluma-story-section-2 .story-section-text-holder>div {
        padding: 32px 0;

    }

    .lanluma-story-section-2 .story-section-text-holder h3 {
        font-size: 1.25rem;
    }

    /* .lanluma-story-section-2 .story-section-text-holder span {
        margin-bottom: 40px
    } */

    .lanluma-story-section-3 .story-section-text-holder span {
        padding-bottom: 30px;

    }

    .lanluma-story-section-3 {
        padding-bottom: 0 !important;
    }

    .lanluma-story-section-3 .image-box,
    .maili-story-section-1 .image-box,
    .maili-story-section-2 .image-box,
    .dimono-story-section-1 .image-box,
    .about .image-box {
        display: none;
    }

    .story-section-text-holder>div {
        padding: 16px !important;
    }

    .maili-story-section-2 {
        padding-bottom: 0 !important;
    }

    .maili-story-section-2 h3 {
        font-size: 1.25rem;
    }

    .maili-story-section-2 .story-section-text-holder>div {
        padding: 32px 16px !important;
    }

    .drcyj-story-section-1 .image-box {
        order: 2;
    }

    .drcyj-story-section-1 .image-box>div {

        width: 100%;
        position: relative;
        top: 10% !important;
        left: 0;
        height: 100%;
    }

    .about>div>div {
        padding: 0 !important
    }

    .about h3 {
        font-size: 1.25rem !important;
    }

    .about p {
        font-size: 0.8375rem !important;
        padding-bottom: 40px;
    }


}

.story-section-parent.ellanse-story-section-3 .first-stack span,
.story-section-parent.lanluma-story-section-3 .first-stack span {

    margin-top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/about/components/StorySection.css"],"names":[],"mappings":";;AAEA;;IAEI,0BAA0B;;AAE9B;;AAEA;IACI;;;;;QAKI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;;IAGA;QACI,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;AACJ;IACI,gBAAgB;AACpB;IACI;QACI,4BAA4B;QAC5B,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,2BAA2B;IAC/B;IACA;QACI,cAAc;QACd,iBAAiB;IACrB;IACA;QACI,cAAc;QACd,uBAAuB;IAC3B;IACA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;IAC9B;;;IAGA;QACI,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,aAAa;QACb,MAAM;IACV;;IAEA;QACI,aAAa;IACjB;;IAEA;;OAEG;;;;IAIH;QACI,kCAAkC;IACtC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;;;;;;QAMI,0BAA0B;QAC1B,8BAA8B;IAClC;;;;IAIA;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;;QAE1B,8BAA8B;IAClC;;;;IAIA;;;QAGI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;;QAEI,kBAAkB;QAClB,kBAAkB;IACtB;;;;IAIA;;;;;;QAMI,2BAA2B;QAC3B,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;;QAE3B,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;QAC/B,0BAA0B;IAC9B;;;IAGA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;;;QAGI,0BAA0B;;IAE9B;;IAEA;QACI,4BAA4B;QAC5B,6BAA6B;QAC7B,8BAA8B;IAClC;;;IAGA;QACI,kBAAkB;;IAEtB;;IAEA;QACI,8BAA8B;;IAElC;;IAEA;QACI,4BAA4B;IAChC;;;IAGA;QACI,kBAAkB;;IAEtB;;IAEA;QACI,4BAA4B;IAChC;;;;;IAKA;QACI,eAAe;QACf,yBAAyB;IAC7B;;IAEA;;QAEI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,2BAA2B;QAC3B,iBAAiB;IACrB;;IAEA;;;OAGG;;IAEH;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;;;QAGI,8BAA8B;IAClC;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;QAC/B,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,kCAAkC;QAClC,+BAA+B;;IAEnC;;IAEA;QACI,6BAA6B;IACjC;;;AAGJ;;;AAGA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;IACA;QACI,0BAA0B;QAC1B,+BAA+B;IACnC;IACA;QACI,2BAA2B;QAC3B,6BAA6B;IACjC;IACA;QACI,aAAa;QACb,MAAM;IACV;IACA;;QAEI,8BAA8B;IAClC;IACA;;;;;;;QAOI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;;;;AAIA;;IAEI;QACI,aAAa;IACjB;;;IAGA;QACI,qBAAqB;IACzB;;IAEA;QACI;8BACsB;QACtB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;QAC5B,mBAAmB;;IAEvB;;IAEA;QACI,2BAA2B;IAC/B;;;IAGA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,8BAA8B;QAC9B,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;;IAE9B;;IAEA;QACI,mBAAmB;;IAEvB;;IAEA;QACI,6BAA6B;QAC7B,6BAA6B;QAC7B,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,mBAAmB;QACnB,kBAAkB;;IAEtB;;IAEA;QACI,2BAA2B;QAC3B,+BAA+B;QAC/B,4BAA4B;;IAEhC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;;;;QAII,2BAA2B;IAC/B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA,8BAA8B;IAC9B;;;;;;;;;;QAUI,kBAAkB;QAClB,mBAAmB;QACnB,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;;OAGG;;IAEH;;;;;;QAMI,iBAAiB;;IAErB;;IAEA;QACI,2BAA2B;QAC3B,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;QAC3B,kBAAkB;;IAEtB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;;;;;;;;;;QAUI,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;;;;;QAKI,4BAA4B;IAChC;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,4BAA4B;IAChC;;IAEA;;;QAGI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;;IAElC;;IAEA;QACI,2BAA2B;QAC3B,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;;QAEI,2BAA2B;QAC3B,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;;IAElC;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;;QAEI,2BAA2B;QAC3B,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;AACJ;;AAEA;;IAEI;;QAEI,oCAAoC;IACxC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,qBAAqB;QACrB,wBAAwB;QACxB,gBAAgB;;IAEpB;;IAEA;QACI,mCAAmC;QACnC,WAAW;;QAEX,iBAAiB;QACjB,WAAW;QACX,YAAY;;IAEhB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;;IAGA;QACI,YAAY;QACZ,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,OAAO;QACP,YAAY;IAChB;;IAEA;QACI,yBAAyB;;QAEzB,6BAA6B;QAC7B,8BAA8B;;;IAGlC;;IAEA;;;QAGI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,+BAA+B;IACnC;;IAEA;QACI;sCAC8B;QAC9B,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,OAAO;QACP,aAAa;QACb,WAAW;QACX,yDAAuE;QACvE,4BAA4B;QAC5B,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,wBAAwB;QACxB,OAAO;QACP,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,6BAA6B;;IAEjC;;IAEA;;QAEI,SAAS;QACT,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;;;;QAII,sBAAsB;IAC1B;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,UAAU;IACd;;IAEA;QACI,SAAS;QACT,yBAAyB;QACzB,gBAAgB;QAChB,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,MAAM;;QAEN,OAAO;QACP,WAAW;;IAEf;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,+BAA+B;QAC/B,iBAAiB;;IAErB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;IACd;;;IAGA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;OAEG;;IAEH;QACI,oBAAoB;;IAExB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;;;;;QAKI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,QAAQ;IACZ;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,OAAO;QACP,YAAY;IAChB;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;QAC/B,oBAAoB;IACxB;;;AAGJ;;AAEA;;;IAGI,wBAAwB;AAC5B","sourcesContent":["\n\nhtml[dir='rtl'] .lanluma-story-section-1 .image-box>div>div,\nhtml[dir='rtl'] .ellanse-story-section-1 .image-box>div>div {\n    transform: none !important;\n\n}\n\n@media(min-width: 992px) {\n    html[dir='ltr'] .story-section-parent\n\n    /* ,\n    html[dir='rtl'] .story-section-parent.reverse  */\n        {\n        padding-left: 48px !important;\n        padding-right: 72px !important;\n    }\n\n    html[dir='rtl'] .story-section-parent {\n        padding-right: 48px !important;\n        padding-left: 72px !important;\n    }\n\n    html[dir='ltr'] .story-section-parent.reverse {\n        padding-right: 48px !important;\n        padding-left: 96px !important;\n    }\n\n\n    html[dir='rtl'] .story-section-parent.reverse {\n        padding-right: 32px !important;\n        padding-left: 0 !important;\n    }\n\n    .story-section-parent .min-height-controller {\n        min-height: 440px;\n    }\n.story-section-parent .story-section-text-holder{\n    min-width: 450px;\n}\n    .story-section-parent .first-stack {\n        padding-bottom: 0 !important;\n        padding-top: 75px !important;\n    }\n\n    html[dir='ltr'] .story-section-parent.lanluma-story-section-1 .first-stack {\n        padding-left: 40px !important;\n        padding-right: 0 !important;\n    }\n    .story-section-parent.lanluma-story-section-1{\n        padding-top: 0;\n        padding-bottom: 0;\n    }\n    .story-section-parent.lanluma-story-section-2{\n        padding-top: 0;\n        /* padding-bottom: 0; */\n    }\n    html[dir='ltr'] .story-section-parent .first-stack {\n        padding-left: 32px !important;\n    }\n\n    html[dir='rtl'] .story-section-parent .first-stack {\n        padding-right: 32px !important;\n        padding-left: 0 !important;\n    }\n\n\n    .dimono-story-section-1 .first-stack {\n        padding-right: 32px;\n    }\n\n    .dimono-story-section-1 {\n        padding-bottom: 0 !important;\n    }\n\n    .lanluma-story-section-2 .image-box>div {\n        height: 400px;\n        top: 0;\n    }\n\n    html[dir='rtl'] .lanluma-story-section-2 .image-box>div {\n        height: 420px;\n    }\n\n    /* html[dir='rtl'] .lanluma-story-section-2 .image-box>div {\n        height: 420px;\n    } */\n\n\n\n    .ellanse-story-section-3 .first-stack {\n        /* padding-top: 35px !important; */\n    }\n\n    .renee-story-1 .min-height-controller {\n        min-height: 430px !important;\n    }\n\n    .story-section-parent.drcyj-story-1 .min-height-controller {\n        min-height: 447px !important;\n    }\n\n    .ksurgery-story-2 .min-height-controller {\n        min-height: 435px !important;\n    }\n\n    .story-section-parent.ksurgery-story-2 .first-stack,\n\n    .story-section-parent.lanluma-story-section-2 .first-stack {\n\n\n\n        padding-left: 0 !important;\n        padding-right: 32px !important;\n    }\n\n\n\n    .story-section-parent.ellanse-story-section-2 .min-height-controller {\n        min-height: 450px;\n    }\n\n    .story-section-parent.ellanse-story-section-2 .first-stack {\n        padding-left: 0 !important;\n\n        padding-right: 48px !important;\n    }\n\n\n\n    .story-section-parent.maili-story-section-2 .first-stack,\n\n    .story-section-parent.maili-story-section-1 .first-stack {\n        padding-right: 48px;\n        padding-left: 0;\n    }\n\n    html[dir='rtl'] .story-section-parent.maili-story-section-2 .first-stack,\n    html[dir='rtl'] .story-section-parent.maili-story-section-1 .first-stack {\n        padding-right: 0px;\n        padding-left: 48px;\n    }\n\n\n\n    html[dir='rtl'] .story-section-parent.ksurgery-story-2 .first-stack,\n\n    html[dir='rtl'] .story-section-parent.lanluma-story-section-2 .first-stack {\n\n\n\n        padding-right: 0 !important;\n        padding-left: 32px !important;\n    }\n\n    html[dir='rtl'] .story-section-parent.ellanse-story-section-2 .first-stack {\n        padding-right: 0 !important;\n\n        padding-left: 48px !important;\n    }\n\n    html[dir='rtl'] .story-section-parent.maili-story-section-2.reverse {\n        padding-right: 102px !important;\n        padding-left: 0 !important;\n    }\n\n\n    .story-section-parent.dimono-story-2 .first-stack,\n    .story-section-parent.lanluma-story-section-3 .first-stack {\n        padding-right: 0 !important;\n    }\n\n    html[dir='rtl'] .story-section-parent.dimono-story-2 .first-stack {\n        padding-right: 96px !important;\n        padding-left: 0 !important;\n    }\n\n    .story-section-parent.ellanse-story-section-1 span,\n    .story-section-parent.ellanse-story-section-2 span,\n    .story-section-parent.ellanse-story-section-3 span {\n        font-size: 18px !important;\n\n    }\n\n    .story-section-parent.renee-story-1 .first-stack {\n        padding-top: 48px !important;\n        padding-left: 84px !important;\n        padding-right: 56px !important;\n    }\n\n\n    .story-section-parent.renee-story-2 ul {\n        padding-left: 12px;\n\n    }\n\n    html[dir='rtl'] .story-section-parent.renee-story-2 ul {\n        padding-right: 12px !important;\n\n    }\n\n    .story-section-parent.renee-story-2 .first-stack {\n        padding-top: 70px !important;\n    }\n\n\n    .story-section-parent.ellanse-story-section-1 .first-stack {\n        padding-left: 88px;\n\n    }\n\n    .story-section-parent.ellanse-story-section-3 .min-height-controller {\n        min-height: 440px !important;\n    }\n\n\n\n\n    .story-section-parent .min-height-controller h3 {\n        font-size: 24px;\n        padding-top: 0 !important;\n    }\n\n    .story-section-parent .min-height-controller h3+p,\n    .story-section-parent .min-height-controller h3+span {\n        font-size: 18px;\n        line-height: 1.4;\n        text-align: justify;\n        margin-top: 16px !important;\n        letter-spacing: 0;\n    }\n\n    /* .story-section-parent .min-height-controller h3+ p,\n    .story-section-parent .min-height-controller h3+span {\n        margin-top: 0 !important;\n    } */\n\n    html[dir='rtl'] .lanluma-story-section-2.story-section-parent.reverse {\n        padding-right: 96px !important;\n    }\n\n    html[dir='rtl'] .maili-story-section-2.story-section-parent.reverse .first-stack {\n        padding-left: 56px !important;\n    }\n\n    html[dir='ltr'] .maili-story-section-2.story-section-parent.reverse,\n\n    html[dir='ltr'] .ksurgery-story-2.story-section-parent.reverse {\n        padding-left: 102px !important;\n    }\n\n    html[dir='ltr'] .drcyj-story-section-1.story-section-parent .first-stack,\n    html[dir='ltr'] .ksurgery-story-1.story-section-parent .first-stack {\n        padding-right: 0 !important;\n    }\n\n    html[dir='ltr'] .renee-story-2.story-section-parent.reverse {\n        padding-left: 124px !important;\n    }\n\n    html[dir='rtl'] .renee-story-2.story-section-parent.reverse {\n        padding-right: 124px !important;\n        padding-left: 48px !important;\n    }\n\n    .renee-story-2.story-section-parent.reverse h3 {\n        padding-top: 0 !important;\n    }\n\n    html[dir='ltr'] .ksurgery-story-2.story-section-parent.reverse .first-stack {\n        padding-right: 56px !important;\n    }\n\n    html[dir='rtl'] .ksurgery-story-2.story-section-parent.reverse {\n        /* padding-left: 56px!important; */\n        padding-right: 102px !important;\n\n    }\n\n    html[dir='rtl'] .ksurgery-story-2.story-section-parent.reverse .first-stack {\n        padding-left: 48px !important;\n    }\n\n\n}\n\n\n@media(min-width: 1440px){\n    html[dir='ltr'] .story-section-parent.reverse {\n        padding-right: 0 !important;\n        padding-left: 102px !important;\n    }\n    html[dir='rtl'] .story-section-parent.reverse {\n        padding-left: 0 !important;\n        padding-right: 102px !important;\n    }\n    html[dir='ltr'] .story-section-parent.reverse {\n        padding-right: 0 !important;\n        padding-left: 96px !important;\n    }\n    .lanluma-story-section-2 .image-box>div {\n        height: 420px;\n        top: 0;\n    }\n    html[dir='ltr'] .story-section-parent.renee-story-1 .first-stack {\n     \n        padding-right: 86px !important;\n    }\n    html[dir='ltr'] .story-section-parent.maili-story-section-1 .first-stack,\n    \n   html[dir='ltr'] .story-section-parent.ellanse-story-section-1 .first-stack,\n   html[dir='ltr'] .story-section-parent.ellanse-story-section-3 .first-stack,\n   html[dir='ltr'] .story-section-parent.dimono-story-section-1 .first-stack\n\n    {\n        padding-left: 40px;\n        padding-right: 0;\n    }\n}\n\n\n\n@media(min-width: 768px) and (max-width: 991px) {\n\n    .story-section-parent .min-height-controller {\n        height: 350px;\n    }\n\n\n    .story-section-parent>div {\n        padding: 0 !important;\n    }\n\n    .story-section-parent {\n        /* padding-left: 48px;\n        padding-right: 48px; */\n        padding-left: 64px;\n        padding-right: 64px;\n    }\n\n    .story-section-parent .first-stack {\n        padding-bottom: 0 !important;\n        padding-right: 36px;\n\n    }\n\n    .story-section-parent .image-box>div>div {\n        background-position: center;\n    }\n\n\n    .story-section-parent .first-stack h3 {\n        font-size: 1.25rem;\n    }\n\n    .story-section-parent span,\n    .story-section-parent p {\n        text-align: justify !important;\n        font-size: 14px;\n        line-height: 1.4 !important;\n    }\n\n    .story-section-parent.renee-story-1 {\n        padding-left: 60px;\n        padding-right: 60px;\n    }\n\n    .story-section-parent.renee-story-2 {\n        padding-left: 88px !important;\n        padding-right: 88px !important;\n    }\n\n    .story-section-parent.renee-story-2 ul {\n        width: 100% !important;\n    }\n\n    .story-section-parent.ksurgery-story-1 {\n\n        padding-left: 60px;\n        padding-right: 60px;\n    }\n\n    .story-section-parent.ksurgery-story-2 {\n        padding-left: 64px;\n        padding-right: 64px;\n    }\n\n    .story-section-parent.ksurgery-story-1 span {\n        /* word-spacing: 0; */\n        letter-spacing: 0;\n    }\n\n    html[dir='rtl'] .ksurgery-story-1.story-section-parent .first-stack {\n        padding-left: 0 !important;\n        padding-right: 48px !important;\n    }\n\n    html[dir='rtl'] .ksurgery-story-2.story-section-parent .first-stack {\n        padding-right: 0 !important;\n        padding-left: 60px !important;\n    }\n\n    .renee-story-1 p {\n        font-size: 14px !important;\n\n    }\n\n    .renee-story-1 .first-stack {\n        padding-right: 40px;\n\n    }\n\n    .drcyj-story-section-1 .first-stack {\n        padding-left: 48px !important;\n        padding-right: 0px !important;\n        padding-top: 40px !important;\n        padding-bottom: 48px !important;\n    }\n\n    .renee-story-2 .first-stack {\n        padding-left: 0;\n        padding-right: 100px;\n        padding-top: 32px;\n        padding-bottom: 64px;\n    }\n\n    .renee-story-2 .first-stack ul {\n        padding-left: 12px !important;\n        line-height: 1.6;\n    }\n\n    .renee-story-2 .first-stack li {\n        font-size: 14px !important;\n    }\n\n    .ksurgery-story-1,\n    .ksurgery-story-2 {\n        padding-right: 12px;\n        padding-left: 12px;\n\n    }\n\n    .ksurgery-story-1 .first-stack {\n        padding-right: 0 !important;\n        padding-bottom: 40px !important;\n        padding-top: 36px !important;\n\n    }\n\n    .ksurgery-story-1 .min-height-controller {\n        min-height: 350px !important;\n    }\n\n    .ksurgery-story-1 span {\n        line-height: 1.4 !important;\n    }\n\n    .ksurgery-story-2 .first-stack {\n        padding-left: 0 !important;\n        padding-right: 48px;\n    }\n\n    .story-section-parent.ksurgery-story-2 span {\n        font-size: 14px !important;\n    }\n\n    .ksurgery-story-2 .image-box>div,\n    .maili-story-section-2 .image-box>div,\n    .ellanse-story-section-2 .image-box>div {\n        left: -56px !important;\n    }\n\n    .lanluma-story-section-1 .first-stack,\n\n    .maili-story-section-1 .first-stack {\n\n        padding-right: 0 !important;\n    }\n\n    .lanluma-story-section-1 .min-height-controller,\n    .maili-story-section-1 .min-height-controller {\n        min-height: 350px !important;\n    }\n\n    .ellanse-story-section-2 .min-height-controller {\n        min-height: 400px !important;\n    }\n\n    .lanluma-story-section-1 {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n\n    /* .lanluma-story-section-1, */\n    .lanluma-story-section-2,\n    .lanluma-story-section-3,\n    .maili-story-section-1,\n    .maili-story-section-2,\n    .ellanse-story-section-1,\n    .ellanse-story-section-2,\n    .ellanse-story-section-3,\n    .renee-story-1,\n    .drcyj-story-section-1,\n    .dimono-story-section-1 {\n        padding-left: 60px;\n        padding-right: 60px;\n        padding-top: 32px !important;\n    }\n\n    html[dir='rtl'] .dimono-story-section-1 .first-stack {\n        padding-left: 0 !important;\n        padding-right: 44px !important;\n    }\n\n    .dimono-story-section-1 span {\n        word-spacing: 0;\n        letter-spacing: 0;\n    }\n\n    .renee-story-2 {\n        padding: 40px !important;\n    }\n\n    /* .maili-story-section-1,.maili-story-section-2{\n        padding-left: 24px;\n        padding-right: 24px;\n    } */\n\n    .lanluma-story-section-1 .first-stack,\n    .lanluma-story-section-2 .first-stack,\n    .ellanse-story-section-1 .first-stack,\n    .lanluma-story-section-3 .first-stack,\n\n    .maili-story-section-1 .first-stack {\n        padding-top: 48px;\n\n    }\n\n    .ellanse-story-section-3 .first-stack {\n        padding-top: 8px !important;\n        padding-right: 8px !important;\n    }\n\n    .story-section-parent h3 {\n        font-weight: 600 !important;\n        font-size: 1.25rem;\n\n    }\n\n    .story-section-parent .first-stack {\n        padding-bottom: 0 !important;\n    }\n\n    .lanluma-story-section-1 span,\n    .lanluma-story-section-2 span,\n    .lanluma-story-section-3 span,\n    .maili-story-section-1 span,\n    .ellanse-story-section-1 span,\n    .ellanse-story-section-2 span,\n    .ellanse-story-section-3 span,\n\n\n    .drcyj-story-section-1 span {\n        font-size: 14px !important;\n        line-height: 1.4;\n    }\n\n    .lanluma-story-section-2 .min-height-controller,\n    .maili-story-section-1 .min-height-controller,\n    .ellanse-story-section-2 .min-height-controller,\n    .ellanse-story-section-1 .min-height-controller,\n    .ellanse-story-section-3 .min-height-controller {\n        min-height: 350px !important;\n    }\n\n    .lanluma-story-section-2 .first-stack,\n    .maili-story-section-2 .first-stack,\n    .ellanse-story-section-2 .first-stack {\n        padding-left: 0;\n    }\n\n    .lanluma-story-section-2 .image-box>div {\n        left: -55px;\n    }\n\n    .lanluma-story-section-3 .min-height-controller {\n        min-height: 350px !important;\n    }\n\n    .lanluma-story-section-3 .first-stack,\n    .ellanse-story-section-1 .first-stack,\n    .dimono-story-section-1 .first-stack {\n        padding-right: 0 !important;\n    }\n\n    html[dir='rtl'] .drcyj-story-section-1 .first-stack {\n        padding-left: 0 !important;\n        padding-right: 48px !important;\n    }\n\n    .story-section-parent.drcyj-story-section-1 .min-height-controller {\n        height: 370px;\n    }\n\n    .story-section-parent.maili-story-section-2 .first-stack {\n        padding-right: 48px !important;\n\n    }\n\n    html[dir='rtl'] .story-section-parent.maili-story-section-2 .first-stack {\n        padding-right: 0 !important;\n        padding-left: 60px !important;\n    }\n\n    html[dir='rtl'] .story-section-parent.maili-story-section-1 .first-stack {\n        padding-left: 0 !important;\n        padding-right: 44px !important;\n    }\n\n    .story-section-parent.lanluma-story-section-1 {\n        padding-left: 68px !important;\n        padding-right: 68px !important;\n    }\n\n    html[dir='rtl'] .story-section-parent.lanluma-story-section-1 .first-stack {\n        padding-left: 0 !important;\n        padding-right: 44px !important;\n    }\n\n    html[dir='rtl'] .story-section-parent.lanluma-story-section-2 {\n        padding-left: 24px !important;\n        padding-right: 64px !important;\n    }\n\n    html[dir='rtl'] .story-section-parent.lanluma-story-section-2 .first-stack {\n\n        padding-right: 0 !important;\n        padding-left: 48px !important;\n    }\n\n    html[dir='rtl'] .lanluma-story-section-3 .first-stack {\n        padding-left: 0 !important;\n        padding-right: 48px !important;\n\n    }\n\n    html[dir='ltr'] .lanluma-story-section-2 {\n        padding-left: 64px !important;\n        padding-right: 34px !important;\n    }\n\n    html[dir='rtl'] .ellanse-story-section-1 .first-stack {\n        padding-left: 0 !important;\n        padding-right: 48px !important;\n    }\n\n    html[dir='rtl'] .ellanse-story-section-2 {\n\n        padding-right: 0 !important;\n        padding-left: 60px !important;\n    }\n\n    html[dir='rtl'] .ellanse-story-section-2 {\n        padding-left: 40px !important;\n        padding-right: 64px !important;\n    }\n\n    html[dir='rtl'] .ellanse-story-section-2 .first-stack {\n        padding-right: 0;\n        padding-left: 60px;\n    }\n\n    html[dir='rtl'] .ellanse-story-section-3 .first-stack {\n        padding-left: 0;\n        padding-right: 48px !important;\n    }\n\n    .ellanse-story-section-2 .min-height-controller {\n        min-height: 400px !important;\n    }\n\n    html[dir='ltr'] .ellanse-story-section-2 {\n        padding-left: 64px !important;\n        padding-right: 53px !important;\n    }\n}\n\n@media(min-width: 768px) {\n\n    .ksurgery-story-1,\n    .ksurgery-story-2 {\n        background-color: #E0FFF5 !important;\n    }\n}\n\n@media(max-width:767px) {\n    .ksurgery-story-1 .image-box {\n        display: none;\n    }\n\n    .ksurgery-story-2 {\n        padding-top: 0 !important;\n    }\n\n    .ksurgery-story-2 .image-box {\n        transform: scaleX(-1);\n        height: 285px !important;\n        margin-bottom: 0;\n\n    }\n\n    .ksurgery-story-2 .image-box>div {\n        /* position: relative !important; */\n        width: 105%;\n\n        top: 0 !important;\n        left: -16px;\n        height: 100%;\n\n    }\n\n    .ksurgery-story-2 .image-box>div>div {\n        background-size: cover;\n        margin-top: 32px;\n    }\n\n\n    .renee-story-1 .image-box {\n        height: 60vh;\n        order: 2;\n        margin-top: 36px;\n    }\n\n    .renee-story-1 .image-box>div {\n        width: 105%;\n        top: 0 !important;\n        left: 0;\n        height: 100%;\n    }\n\n    .renee-story-2 {\n        padding-top: 0 !important;\n\n        padding-left: 16px !important;\n        padding-right: 16px !important;\n\n\n    }\n\n    .renee-story-2 .image-box,\n    .ellanse-story-section-1 .image-box,\n    .lanluma-story-section-1 .image-box {\n        display: none;\n    }\n\n    .lanluma-story-section-1 {\n        margin-top: 100px;\n        padding-bottom: 84px !important;\n    }\n\n    html[dir='rtl'] .lanluma-story-section-1 {\n        /* margin-top: 100px;\n    padding-bottom: 84px !important; */\n        width: 110%;\n    }\n\n    .lanluma-story-section-1 .story-section-text-holder {\n        margin-top: 45px;\n    }\n\n    .lanluma-story-section-1 .story-section-text-holder {\n        position: relative;\n        padding-top: 0 !important;\n    }\n\n    .lanluma-story-section-1 .story-section-text-holder:before {\n        content: \"\";\n        position: absolute;\n        bottom: 106%;\n        left: 0;\n        height: 147px;\n        width: 100%;\n        background-image: url('../../../assets/lanluma/story-section-1-bg.svg');\n        background-repeat: no-repeat;\n        background-size: cover !important;\n    }\n\n    .renee-story-2 li {\n        text-align: left;\n    }\n\n    html[dir='rtl'] .renee-story-2 li {\n        text-align: right;\n    }\n\n    .renee-story-2 h3 {\n        font-size: 1.25rem;\n    }\n\n    .ellanse-story-section-2 {\n        padding-top: 0 !important;\n    }\n\n    .lanluma-story-section-1 .story-section-text-holder {\n        height: 40vh;\n    }\n\n    .lanluma-story-section-1 .story-section-text-holder>div {\n        padding: 32px !important;\n        left: 0;\n        position: relative;\n        width: 100%;\n        top: -15px;\n    }\n\n    html[dir='rtl'] .lanluma-story-section-1 .story-section-text-holder>div {\n        padding: 32px 48px !important;\n\n    }\n\n    html[dir='rtl'] .lanluma-story-section-1 .story-section-text-holder:before {\n\n        left: 49%;\n        transform: translateX(-50%);\n        /* bottom: 106%; */\n    }\n\n    html[dir='ltr'] .lanluma-story-section-1 {\n        padding-bottom: 72px !important;\n    }\n\n    html[dir='rtl'] .lanluma-story-section-1 {\n        padding-bottom: 20px !important;\n    }\n\n    html[dir='rtl'] .ellanse-story-section-2 .image-box,\n    html[dir='rtl'] .ellanse-story-section-3 .image-box,\n    html[dir='rtl'] .ksurgery-story-2 .image-box,\n    html[dir='rtl'] .renee-story-1 .image-box {\n        left: -16px !important;\n    }\n\n    .renee-story-2 ul {\n        padding-left: 12px\n    }\n\n    html[dir='rtl'] .renee-story-2 ul {\n        padding-right: 12px\n    }\n\n    html[dir='rtl'] .ellanse-story-section-3 {\n        padding-top: 56px;\n    }\n\n    .lanluma-story-section-1 .story-section-text-holder>div {\n\n        top: -25px;\n    }\n\n    .ellanse-story-section-2 .image-box {\n        order: -1;\n        padding-top: 0 !important;\n        margin-top: -8px;\n        transform: scaleX(-1);\n        left: 16px;\n    }\n\n    .ellanse-story-section-3 .image-box>div {\n        top: 0;\n\n        left: 0;\n        height: 80%;\n\n    }\n\n    .ellanse-story-section-3 .story-section-text-holder {\n        padding-top: 0;\n        margin-top: -20px;\n    }\n\n    .lanluma-story-section-2 {\n        padding-top: 0 !important;\n        padding-bottom: 30px !important;\n        margin-top: -27px;\n\n    }\n\n    .lanluma-story-section-2 .image-box {\n        display: none;\n    }\n\n    .lanluma-story-section-1>div>div {\n        width: 100%;\n        position: relative;\n        left: 16px;\n    }\n\n\n    .lanluma-story-section-1 .story-section-text-holder {\n        padding-left: 0 !important;\n    }\n\n    .lanluma-story-section-2 .story-section-text-holder {\n        padding-top: 0 !important;\n    }\n\n    .lanluma-story-section-2 .story-section-text-holder>div {\n        padding: 32px 0;\n\n    }\n\n    .lanluma-story-section-2 .story-section-text-holder h3 {\n        font-size: 1.25rem;\n    }\n\n    /* .lanluma-story-section-2 .story-section-text-holder span {\n        margin-bottom: 40px\n    } */\n\n    .lanluma-story-section-3 .story-section-text-holder span {\n        padding-bottom: 30px;\n\n    }\n\n    .lanluma-story-section-3 {\n        padding-bottom: 0 !important;\n    }\n\n    .lanluma-story-section-3 .image-box,\n    .maili-story-section-1 .image-box,\n    .maili-story-section-2 .image-box,\n    .dimono-story-section-1 .image-box,\n    .about .image-box {\n        display: none;\n    }\n\n    .story-section-text-holder>div {\n        padding: 16px !important;\n    }\n\n    .maili-story-section-2 {\n        padding-bottom: 0 !important;\n    }\n\n    .maili-story-section-2 h3 {\n        font-size: 1.25rem;\n    }\n\n    .maili-story-section-2 .story-section-text-holder>div {\n        padding: 32px 16px !important;\n    }\n\n    .drcyj-story-section-1 .image-box {\n        order: 2;\n    }\n\n    .drcyj-story-section-1 .image-box>div {\n\n        width: 100%;\n        position: relative;\n        top: 10% !important;\n        left: 0;\n        height: 100%;\n    }\n\n    .about>div>div {\n        padding: 0 !important\n    }\n\n    .about h3 {\n        font-size: 1.25rem !important;\n    }\n\n    .about p {\n        font-size: 0.8375rem !important;\n        padding-bottom: 40px;\n    }\n\n\n}\n\n.story-section-parent.ellanse-story-section-3 .first-stack span,\n.story-section-parent.lanluma-story-section-3 .first-stack span {\n\n    margin-top: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
